import React from 'react';
import AvatarSection from './AvatarSection';
import MyFeedLink from '@sls-react/components/Links/MyFeedLink';
import SwapsInboxLink from '@sls-react/components/Links/SwapsInboxLink';
import LoginLink from '@sls-react/components/Links/LoginLink';
import RegisterLink from '@sls-react/components/Links/RegisterLink';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useSession } from '@sls-react/contexts/SessionContext';
import CartButton from '@sls-react/components/Chrome/Header/CartButton';
import { useQuery } from 'react-query';
import { fetchBadgeCount } from '@sls-react/api/swaps';
import FavoriteIcon from '@sls-react/static/svg/FavoriteIcon';
import { SwapsIcon } from '@sls-react/static/svg/ItemActionIcons';
import SellNowLink from '@sls-react/components/Links/SellNowLink';

const UserSectionBase = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  flex-shrink: 0;

  > * {
    margin-right: 16px;
    transition: color 0.1s, background 0.1s;

    &:last-child {
      margin-right: 0;
    }
  }

  button:not(.sell),
  a {
    color: ${themeGet('colors.black')};

    &:hover {
      color: ${themeGet('colors.green')};
    }
  }
`;

const MySwaps = () => {
  const { loggedIn } = useSession();
  const { data } = useQuery('badge-count', fetchBadgeCount, {
    enabled: loggedIn,
  });

  return (
    <SwapsInboxLink className="flex flex-col items-center">
      <div className="relative">
        <SwapsIcon fill="currentColor" />
        {data?.badge! > 0 && (
          <div
            className="absolute px-1 text-xs text-white rounded bg-primary-500"
            style={{ top: -4, right: -8 }}
          >
            {data?.badge}
          </div>
        )}
      </div>
      <div className="text-xs text-center">My Swaps</div>
    </SwapsInboxLink>
  );
};

const UserSection: React.FC = () => {
  const { loggedIn } = useSession();

  const sell = (
    <SellNowLink className="px-4 font-semibold border-2 rounded py-1.5 border-turf-green-500">
      Sell
    </SellNowLink>
  );

  if (loggedIn) {
    // LOGGED IN
    return (
      <UserSectionBase>
        {sell}

        <MyFeedLink className="flex flex-col items-center">
          <FavoriteIcon fill="currentColor" />
          <div className="text-xs text-center">Favorites</div>
        </MyFeedLink>

        <MySwaps />

        <CartButton showLabel />

        <AvatarSection />
      </UserSectionBase>
    );
  }

  return (
    <UserSectionBase>
      {sell}

      <MyFeedLink className="flex flex-col items-center">
        <FavoriteIcon fill="currentColor" />
        <div className="text-xs text-center">Favorites</div>
      </MyFeedLink>

      <CartButton showLabel />

      <LoginLink>Sign In</LoginLink>

      <RegisterLink>Join</RegisterLink>
    </UserSectionBase>
  );
};

export default UserSection;
